module.exports = __webpack_public_path__ + "static/media/veryvell_5_filter.e3ce741f.png";